import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaHome } from 'react-icons/fa';

const Header = ({ show, setShow }) => {
  return (
    <header className="header">
      <div className="header__inner">
        <div>
          {show ? (
            <FaTimes className="header__icon" onClick={setShow} />
          ) : (
            <FaBars className="header__icon" onClick={setShow} />
          )}

          <Link to="/">
            <FaHome className="header__icon" />
          </Link>
        </div>

        <Link to="/" className="header__logo">
          TodoApp
        </Link>
      </div>
    </header>
  );
};

export default Header;
